<div id="PhotoGallery">
    <div class="title">
        <h1>
            Admin Page
        </h1>
        <h2 class="secondary">
            GALLERIA FOTO
        </h2>

    </div>
    <div class="content">
        <div class="box" @click="openFileManager">
            <div class="dotted" @dragover.prevent @drop="handleDrop">
                <h3>Drop here</h3>
                <input type="file" ref="fileInput" style="display: none;" multiple @change="onFileChange">
            </div>
        </div>
        <div v-for="image in images" :key="image.imgName" class="box box-img"
            :style="{ backgroundImage: `url(${serverUrl}/galleria/immagine/${image.imgName})` }">
            <div class="x-button" @click="onDeleteImage(image._id)">
                <img src="../../../public/x.png" />
            </div>

        </div>

    </div>

</div>